<div class="wrapper">
	<div class="header_block">
		<ion-icon (click)="dismiss()" class="cross" src="../../../assets/topgolf/cross.svg"></ion-icon>
	</div>
	<h3 class="title">{{ 'filters.filter_title' | translate }}</h3>

	<div class="options">
		@for (option of listFilters; track option) {
			<div (click)="toggle(option)" class="option">
				<div [class.active]="isSelected(option)" class="switch">
					<div class="knob"></div>
				</div>
				<span>{{ option.name | translate }}</span>
			</div>
		}
	</div>

	<div class="footer-item">
		<ion-button (click)="confirm()"> {{ 'checkout_modal.confirm' | translate }}</ion-button>
	</div>
</div>
